<section class="container d-flex flex-column justify-content-center min-vh-100 py-5">
  <ng-lottie [options]="animationOptions" class="mt-n5 h-96"></ng-lottie>
  <div class="text-center pt-4 mt-lg-2">
    <h1 class="display-5">Eveniment suspendat</h1>
    <p class="fs-lg pb-2 pb-md-0 mb-4 mb-md-5">Evenimentul este temporar suspendat!
    </p>
    <a [routerLink]="['/']" class="btn btn-lg btn-primary">Pagina principala</a>
  </div>
</section>
